import type { LegacyRef } from 'react';

import { cn } from '@pesto/utils';
import { forwardRef, type FC, type FormHTMLAttributes, type KeyboardEvent } from 'react';

interface FormProps extends FormHTMLAttributes<HTMLFormElement> {
  children: React.ReactNode;
  className?: string;
}

export const Form: FC<FormProps> = forwardRef(
  ({ children, onSubmit, className, ...props }, ref: LegacyRef<HTMLFormElement>) => {
    const handleKeyPress = (e: KeyboardEvent<HTMLFormElement>) => {
      if (e.target instanceof Element && e.target.closest('[role="dialog"]')) {
        return;
      }

      if (e.key === 'Enter') {
        e.preventDefault();
        onSubmit?.(e);
      }
    };

    const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
      e.preventDefault();
      onSubmit?.(e);
    };

    return (
      <form
        {...props}
        onKeyDown={handleKeyPress}
        onSubmit={handleSubmit}
        className={cn('space-y-4', className)}
        ref={ref}
      >
        {children}
      </form>
    );
  },
);
